import { sdk } from 'src/utilities/sdk';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

export const deactivateDiner = async (
  corpId: string,
  dinerId: string
): Promise<IAsyncTaskResponse> =>
  sdk.http.delete(`/corp-admin/${corpId}/diners/v2/${dinerId}`);
